var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.85547 12C3.85547 16.9706 7.88491 21 12.8555 21C17.826 21 21.8555 16.9706 21.8555 12C21.8555 7.02944 17.826 3 12.8555 3C7.88491 3 3.85547 7.02944 3.85547 12ZM12.8555 2C7.33262 2 2.85547 6.47715 2.85547 12C2.85547 17.5228 7.33262 22 12.8555 22C18.3783 22 22.8555 17.5228 22.8555 12C22.8555 6.47715 18.3783 2 12.8555 2Z","fill":"currentColor","key":0}),React.createElement("rect",{"x":"5.42725","y":"5.98633","width":"2","height":"8.11368","transform":"rotate(-45 5.42725 5.98633)","fill":"#999999","key":1})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
